import { useEffect, useState } from "react";
import DynamicText from "./DynamicText.tsx";
import LinkHandler from "./LinkHandler.tsx";
import AttributePicker from "../Common/AttributePicker.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";

const Location: React.FC<any> = (data) => {

    const [question, setQuestion] = useState<string>("");
    const [longitudeAttribute, setLongitudeAttribute] = useState<string>("");
    const [latitudeAttribute, setLatitudeAttribute] = useState<string>("");
    const { nodes, setNodes } = useFlowStore();

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as Record<string, string>;
                setQuestion(d.text || "");
                setLongitudeAttribute(d.longitudeAttribute || "");
                setLatitudeAttribute(d.latitudeAttribute || "");
            }
        }
    }, []);

    useEffect(() => {
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        text: question,
                                        longitudeAttribute,
                                        latitudeAttribute,
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });

        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [question, longitudeAttribute, latitudeAttribute]);

    return (
        <div className="node-body">
            <div className="premium-field">
                <label className="label-premium">Question Message</label>
                <DynamicText
                    placeholder="Type value..."
                    value={question}
                    setValue={setQuestion}
                    maxLength={1024}
                    removePad={true}
                />
            </div>
            <div className="premium-field">
                <label className="label-premium">Select Longitude Attribute</label>
                <AttributePicker
                    value={longitudeAttribute}
                    onChange={setLongitudeAttribute}
                    placeholder="Select attribute"
                    defaultType="NUMBER"
                />
            </div>
            <div className="premium-field">
                <label className="label-premium">Select Latitude Attribute</label>
                <AttributePicker
                    value={latitudeAttribute}
                    onChange={setLatitudeAttribute}
                    placeholder="Select attribute"
                    defaultType="NUMBER"
                />
            </div>
            <LinkHandler />
        </div>
    )
}

export default Location;
